<h1 mat-dialog-title> Detalle Pago </h1> <br/>

<mat-dialog-content>
    <p>
        <mat-form-field appearance = "outline" class = "mat-input">

            <mat-label> Id Grupo Pago: </mat-label>
            
            <input matInput placeholder = "id Grupo" [(ngModel)] = "data.idGrupo" required [disabled] = "true"> 

        </mat-form-field>
    </p>

    <p>
        <mat-form-field appearance = "outline" class = "mat-input">

            <mat-label> Fecha de Pago: </mat-label>
            
            <input matInput placeholder = "fecha de Pago" [(ngModel)] = "data.fechaPago" required [disabled] = "true"> 

        </mat-form-field>
    </p>
    
   
   
</mat-dialog-content>

<div mat-dialog-actions>

    <button mat-button class = "mat-raised-button btn-dark mat-button" (click) = "onCancelarClick()"> 
        <i class = "fa fa-sign-out-alt"> </i> Salir
    </button>
    
</div>